import { Controller } from '@hotwired/stimulus';

const COOKIE = 'sidebar';
const COOKIE_MAX_AGE = 31536000;
const MOBILE_QUERY = '(max-width: 767px)';

export default class extends Controller {
  static targets = ['aside', 'drawer', 'toggle'];

  static values = { collapseLabel: String, expandLabel: String };

  toggle() {
    if (window.matchMedia(MOBILE_QUERY).matches) {
      this.drawerTarget.showModal();
      return;
    }

    const expanded = this.asideTarget.dataset.sidebar === 'collapsed';

    this.#persist(expanded ? 'expanded' : 'collapsed');
    this.#render(expanded);
  }

  closeOnBackdrop(event) {
    if (event.target === this.drawerTarget) this.drawerTarget.close();
  }

  #render(expanded) {
    const label = expanded ? this.collapseLabelValue : this.expandLabelValue;

    this.asideTarget.dataset.sidebar = expanded ? 'expanded' : 'collapsed';
    this.toggleTarget.setAttribute('aria-expanded', String(expanded));
    this.toggleTarget.setAttribute('aria-label', label);
    this.toggleTarget.title = label;
  }

  #persist(state) {
    document.cookie = `${COOKIE}=${state}; path=/; max-age=${COOKIE_MAX_AGE}; samesite=lax`;
  }
}
